<template>
  <div>
    <h3 class="header-title">Billing and Account</h3>
    <label>Let’s see your billing account payment.</label>
    <br />
    <label>
      You have subscribed to the {{ user.packageName }} package, which is valid
      until {{ user.validTo }}. This subscription comes at a price of {{ user.currencyCode}} 
      {{ user.invoiceprice }} and includes a limit of
      {{ check.NumberOfStudent }} students and
      <span v-if="check.TotalTeacher === 0">Unlimited</span
      ><span v-else>{{ check.TotalTeacher }} </span> teachers.
    </label>
    <br />
    <div class="custom-explore">
      <div>
        <CRow>
          <CCol sm="12">
            <div style="width: 80%" class="float-left">
              <img
                src="../assets/img/iconnoti.svg"
                class="ml-5 mr-2 mb-3 mt-3"
              />
              <span class="text-white mt-3 mb-2"> | </span>
              <label class="ml-2 text-white mt-3 mb-2"
                >Billing and Account Information</label
              >
            </div>
            <div style="width: 20%" class="float-right p-0">
              <br /><br />
              <img
                src="../assets/img/icontriangle.svg"
                class="ml-5 mr-2"
                style="
                  position: absolute;
                  top: 0;
                  right: 100px;
                  bottom: 0;
                  height: 55px;
                "
              />
            </div>
          </CCol>
        </CRow>
      </div>
    </div>
    <br />
    <div v-if="user.validTo < currentDate" class="mt-2">
      <CAlert show color="danger">
        <CRow>
          <CCol sm="10">
            <strong class="text-danger mr-2"
          >X ERROR ! Your subscription package has expired. Please renew your
          current subscription or upgrade to a new package.
        </strong>
          </CCol>
          <CCol sm="2" class="text-right">
            <CButton type="button" class="custom-btn-navy" @click="GoToRenew()">Renew</CButton>
          </CCol>

        </CRow>
       
      </CAlert>
    </div>
    <CCol sm="12" class="p-0">
      <CRow class="p-0">
        <CCol sm="6">
          <CCard>
            <div>
              <h6 class="ml-3 mt-3"><strong>Subscription</strong></h6>
              <CRow>
                <CCol sm="5">
                  <img
                    style="max-width: 100%"
                    src="../assets/img/bannerepay.png"
                    class="p-2"
                /></CCol>
                <CCol sm="7">
                  <h6>
                    <strong>{{ user.packageName }} Package</strong>
                  </h6>
                  <label
                    >You can choose to renew by continue existing plan or
                    upgrade new plan
                  </label>
                  <br />
                  <CButton type="submit" color="default" class="btn-secondary" @click="SubmitExisting()"
                    >Continue Existing Plan</CButton
                  >
                  <CButton
                    type="submit"
                    color="default"
                    class="btn-secondary ml-3" @click="GoToRenew()"
                    >Change Plan</CButton
                  >
                </CCol>
              </CRow>
              <br />
            </div>
          </CCard>
        </CCol>
        <CCol sm="2">
          <CCard>
            <h6 class="ml-3 mt-3"><strong>Billing Period</strong></h6>
            <br />
            <h4 class="text-center text-muted">
              <strong v-if="user.TypePay === 1">MONTHLY</strong
              ><strong v-else>YEARLY</strong>
            </h4>
            <label class="text-center"
              >Valid Date till on <br />
              {{  user.validTo }}</label
            >
            <br />
          </CCard>
        </CCol>
      </CRow>
    </CCol>
    <CCol sm="12" class="p-0">
      <CRow>
        <CCol sm="7">
          <CCard class="box-shadow-dashboard">
            <h6 class="ml-3 mt-3"><strong>Billing Information</strong></h6>
            <br />
            <div style="overflow-x: hidden" class="custom-height-performance">
              <table class="table table-bordered">
                <thead>
                  <th>Invoice No</th>
                  <th>Description</th>
                  <th>Invoice Amount</th>
                  <th>Due Date</th>
                </thead>
                <tbody>
                  <tr v-for="item in bill" v-bind:key="item.id">
                    <td>{{ item.invoiceNo }}</td>
                    <td>{{ item.description }}</td>
                    <td>{{ user.currencyCode}}  {{ item.invoiceprice }}</td>
                    <td>{{ item.validTo }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </CCard>
        </CCol>
        <CCol sm="5">
          <CCard class="box-shadow-dashboard">
            <h6 class="ml-3 mt-3"><strong>Billing Info</strong></h6>
            <br />
            <div style="overflow-x: hidden" class="custom-height-performance">
              <CRow>
                <CCol sm="12">
                  <label class="ml-2 mr-2">Edu Center</label>
                  <CInput type="text" v-model="user.name" class="ml-2 mr-2"
                />
                <label class="ml-2 mr-2">Edu Address</label>
                  <CInput type="text" v-model="user.name" class="ml-2 mr-2"
                />
              </CCol>
                <CCol sm="12">
                  <label class="ml-2 mr-2">Phone Number</label>
                  <CInput type="text" v-model="user.phoneNumber" class="ml-2 mr-2"
                />
                <label class="ml-2 mr-2">Email</label>
                  <CInput type="text" v-model="user.email" class="ml-2 mr-2"
                />
                </CCol>
              </CRow>
            </div>
          </CCard>
        </CCol>
      </CRow>
    </CCol>
  </div>
</template>


<script>
import Vue from "vue";
import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.css";
import backgroundUrl from "../assets/img/bgCard.png";

import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { CChartBar } from "@coreui/vue-chartjs";
import VueEllipseProgress from "vue-ellipse-progress";

//import "@fullcalendar/core/vdom"; // solves problem with Vite]

import { Calendar } from "vue-sweet-calendar";
import "vue-sweet-calendar/dist/SweetCalendar.css";
import VueHtmlToPaper from "vue-html-to-paper";
const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
    "../assets/css/pagebreak.css",
  ],
};
Vue.use(VueHtmlToPaper, options);

Vue.use(FullCalendar);
Vue.use(VueEllipseProgress);

export default {
  name: "Collapses",
  components: {
    PulseLoader,
    CChartBar,
    Calendar,
  },
  data() {
    return {
      backgroundUrl,
      user: {},

      currentDate: new Date().toISOString().substring(0, 10),

      check: {},
      bill: {}
    };
  },
  async mounted() {
    this.SessionUserIdNo();
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetListBilling();
    } else {
      this.GoToLogin();
    }
  },
  methods: {
    SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailAdmin, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetCheckTc(this.user.tuitioncenter);
            this.GetListBilling(this.user.userAccountId);
          }
        });
    },
    GetCheckTc(tuitioncenter) {
      return this.$API
        .get(this.$GetCheckTcPackage + "?TuitionCenterId=" + tuitioncenter, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.check = response.data;
          }
        });
    },
    GetListBilling(userAccountId) {
      return this.$API
        .get(
          this.$GetListBillingSubscription + "?userAccountId=" + userAccountId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200) {
            this.bill = response.data;
          }
        });
    },
    GoToRenew()
    {
      window.open("https://www.pickiddo.com/RenewPackage?UserGroupId=" + this.user.usergroupId, "_blank");
    },
    async SubmitExisting() {
      this.Busy = true;
      if (
        this.user.packageId == 1 ||
        this.user.packageId == 8
      ) {
        const formData = new FormData();

        formData.append("UserGroupId", this.user.usergroupId);
        formData.append("PackageId", this.user.packageId);

        return this.$API
          .post(this.$UpdateSubscribePackageFree, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200) {
              window.open("https://ctr.pickiddo.com/#/Billing", "_self");
          } else {
            this.Busy = false;
            this.$dialog
              .alert("Error to create packages")
              .then(function () {});
          }
          })
          .catch((error) => {
            this.Busy = false;
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.message;
          });
      } else {
        const formData = new FormData();

        formData.append("UserGroupId", this.user.usergroupId);
        formData.append("PackageId", this.user.packageId);

        return this.$API
          .post(this.$UpdateRenewPackagePay, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200) {
              this.billId = response.data;
              window.open(
                "https://www.billplz.com/bills/" + this.billId,
                "_self"
              );
            } else {
              this.Busy = false;
              this.$dialog
                .alert("Error to create packagess")
                .then(function () {});
            }
          })
          .catch((error) => {
            this.Busy = false;
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.message;
          });
      }
    },
  },
};
</script>


<style>
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@600&display=swap");
</style>



